import { useRef, useState } from 'react'
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline'
import FormSelect from '@/components/ui/form/FormSelect'
import clsx from 'clsx'

interface FileUploadProps {
  onUpload: (formData: FormData) => void
  kindOptions?: [string, string][]
  kindFieldName?: string
  fileFieldName?: string
}

export default function FileUpload({
  onUpload,
  kindOptions,
  kindFieldName = 'attachment[kind]',
  fileFieldName = 'attachment[file][]',
}: FileUploadProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [fileName, setFileName] = useState<string | null>(null)
  const [kind, setKind] = useState(kindOptions?.[0]?.[0] || '')

  const handleSubmit = () => {
    const file = inputRef.current?.files?.[0]
    if (!file) return
    const formData = new FormData()
    formData.append(fileFieldName, file)
    if (kindOptions && kind) formData.append(kindFieldName, kind)
    onUpload(formData)
    setFileName(null)
    if (inputRef.current) inputRef.current.value = ''
  }

  return (
    <div className="flex items-center gap-2">
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={(e) => setFileName(e.target.files?.[0]?.name || null)}
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        className={clsx(
          'flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-xs font-medium transition-colors',
          fileName
            ? 'border-indigo-300 bg-indigo-50 text-indigo-700 dark:border-indigo-500/30 dark:bg-indigo-500/10 dark:text-indigo-400'
            : 'border-zinc-200 text-zinc-600 hover:bg-zinc-50 dark:border-zinc-600 dark:text-zinc-400 dark:hover:bg-zinc-800'
        )}
      >
        <ArrowUpTrayIcon className="h-3.5 w-3.5" />
        {fileName || 'Choose file'}
      </button>
      {kindOptions && (
        <div className="w-40">
          <FormSelect
            value={kind}
            onChange={setKind}
            options={kindOptions.map(([k, v]) => ({ value: k, label: v }))}
          />
        </div>
      )}
      <button
        type="button"
        onClick={handleSubmit}
        disabled={!fileName}
        className="rounded-md bg-indigo-600 px-2.5 py-1.5 text-xs font-medium text-white hover:bg-indigo-500 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        Upload
      </button>
    </div>
  )
}
